<template>
  <v-card outlined style="margin-bottom: 24px;">
    <UpdateSaleForm
      :state="updateLeadDialog"
      :profile="profile"
      :roles="roles"
      @refresh="refresh"
      @closeDialog="closeUpdate"
    />
    <div class="d-flex justify-space-between align-items-center py-6 pl-6">
      <h5 class=" text-uppercase align-self-center">Thông tin nhân viên</h5>
      <v-btn
        text
        color="blue darken-4"
        class="pr-6 document-btn no-hover"
        plain
        @click="updateLead"
        style="height: 18px;"
      >
        <v-icon left>mdi-playlist-edit</v-icon>
        Cập nhập
      </v-btn>
    </div>

    <v-row class=" px-6 pb-6" no-gutters>
      <v-col cols="4">
        <p class="grey--text mb-0 mt-0">Tên đăng nhập</p>
        <p class=" my-0">{{ profile.username }}</p>
      </v-col>
      <v-col cols="4">
        <p class="grey--text mb-0 mt-0">Email</p>
        <p class=" my-0">{{ profile.email ? profile.email : 'Chưa có thông tin' }}</p>
      </v-col>
      <v-col cols="4">
        <p class="grey--text mb-0 mt-0">Vai trò</p>
        <p class=" my-0">{{ profile.role ? profile.role.type : 'Không có' }}</p>
      </v-col>
    </v-row>
    <v-row class=" px-6 pb-6" no-gutters>
      <v-col cols="4">
        <p class="grey--text mb-0 mt-0">Ngày tạo</p>
        <p class=" my-0">{{ formatTime(profile.createdAt) }}</p>
      </v-col>
      <v-col cols="4">
        <p class="grey--text mb-0 mt-0">Trạng thái</p>
        <p class=" my-0">{{ formatLead(profile.blocked) }}</p>
      </v-col>
    </v-row>
  </v-card>
</template>
<script>
import UpdateSaleForm from './UpdateSaleForm.vue'
import moment from 'moment'

export default {
  props: {
    profile: Object,
    roles: Array
  },
  components: {
    UpdateSaleForm
  },
  data() {
    return {
      updateLeadDialog: false,
      products: []
    }
  },
  methods: {
    updateLead() {
      this.updateLeadDialog = true
    },
    closeUpdate() {
      this.updateLeadDialog = false
    },
    refresh() {
      this.$emit('refresh')
    },
    formatTime(time) {
      return moment(time).format('DD/MM/YYYY')
    },
    formatLead(data) {
      if (data === false) {
        return 'Đang hoạt động'
      } else if (data === true) {
        return 'Đã bị khóa'
      } else {
        return 'Chưa có thông tin'
      }
    }
  }
}
</script>
